<template>
  <span class="p-d-inline-flex"
        v-tooltip.left="billingActionTooltipOptions(
          allowWhenBillingLocked,
          tooltip
        )">
    <Button v-bind="$attrs"
            :disabled="disabled || billingActionIsRestricted(allowWhenBillingLocked)"
            icon="ti-close"
            class="p-button-warning p-button-raised"/>
  </span>
</template>

<script>
import billingRestrictionsMixin from '@/mixins/billingRestrictionsMixin'

export default {
  name: 'RemoveButton',
  inheritAttrs: false,
  mixins: [billingRestrictionsMixin],

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },

    allowWhenBillingLocked: {
      type: Boolean,
      default: false,
    },

    tooltip: {
      type: String,
      default: '',
    },
  },
}
</script>
